import { render, staticRenderFns } from "./myTeam.vue?vue&type=template&id=5fed8ca8&scoped=true"
import script from "./myTeam.vue?vue&type=script&lang=js"
export * from "./myTeam.vue?vue&type=script&lang=js"
import style0 from "./myTeam.vue?vue&type=style&index=0&id=5fed8ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed8ca8",
  null
  
)

export default component.exports